import { render, staticRenderFns } from "./BookType.vue?vue&type=template&id=651e9548&scoped=true"
import script from "./BookType.vue?vue&type=script&lang=js"
export * from "./BookType.vue?vue&type=script&lang=js"
import style0 from "./BookType.vue?vue&type=style&index=0&id=651e9548&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651e9548",
  null
  
)

export default component.exports